export default __webpack_public_path__ + "static/media/support.69569a76.jpg";